import { SvgIcon } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { SvgIconProps } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.grey[50],
    fill: theme.palette.grey[600],
  },
}));

export const MarkerIcon: React.FC<SvgIconProps> = ({ className = '', ...restProps }) => {
  const { classes, cx } = useStyles();

  return (
    <SvgIcon
      className={cx(classes.root, className)}
      viewBox="0 0 16 18"
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63636 13.7741C12.1547 13.0619 14 10.7464 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 10.7464 3.84527 13.0619 6.36364 13.7741V24.3636C6.36364 25.2674 7.09626 26 8 26C8.90374 26 9.63636 25.2674 9.63636 24.3636V13.7741Z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63636 13.7741V24.3636C9.63636 25.2674 8.90374 26 8 26C7.09626 26 6.36364 25.2674 6.36364 24.3636V13.7741C3.84527 13.0619 2 10.7464 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 10.7464 12.1547 13.0619 9.63636 13.7741ZM16 8C16 11.1107 14.2257 13.8034 11.6364 15.127V24.3636C11.6364 26.3719 10.0083 28 8 28C5.99169 28 4.36364 26.3719 4.36364 24.3636V15.127C1.77426 13.8034 0 11.1107 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
